import * as R from "ramda";

import {
  deepFindLineageByUID,
  generateNode,
  replaceNodeByUID,
  setNodeValueByUIDAndKey,
  insertAfterNodeByUIDAtSectionLevel,
  replaceNodeWithArrayByUID,
} from "../doc_helpers";

export function handleNewListInsert<DocContent extends PossibleContent>(
  listType: "regularList" | "numberedList",
  modifyContent: (modifyFunction: ModifyFunction<DocContent>) => void,
  setCurrentlyEditing: (currentlyEditing: CurrentlyEditing | undefined) => void,
  currentlyEditingOverride?: CurrentlyEditing,
) {
  modifyContent((json, currentlyEditing) => {
    const currentSelection = currentlyEditingOverride || currentlyEditing;
    if (!currentSelection) { return json; }

    const lineage = deepFindLineageByUID(json, currentSelection.uid);

    if (!lineage) { return json; }

    const currentlyEditingAncestors = R.init(lineage);
    const currentlyEditingNode = R.last(lineage);

    if (!currentlyEditingNode) { return json; }

    const newNode = generateNode(listType);
    const newListItem = newNode.content[0];

    const newRangeSelection = currentSelection?.range || {start: 0, end: 0};

    switch (currentlyEditingNode.type) {
      case "listItem":
        const parentList = R.findLast((node) => (R.includes(node.type, ["regularList", "numberedList"] as const)), currentlyEditingAncestors);

        if (!parentList) { return json; }

        if (parentList.type === listType) {
          const newParagraph = generateNode("paragraph", {content: currentlyEditingNode.content});

          let replaceWithArray: Array<BlockContent> = [];

          const indexOfNode = parentList.content.findIndex((childNode) => childNode.uid === currentlyEditingNode.uid);
          const numberOfSiblings = parentList.content.length;

          if (indexOfNode > 0) {
            const newFirstList = R.over<NumberedListNode | RegularListNode, Array<ListItemNode>>(R.lensProp("content"), R.slice(0, indexOfNode), parentList);
            replaceWithArray = R.append(newFirstList, replaceWithArray);
          }

          replaceWithArray = R.append(newParagraph, replaceWithArray);

          if (numberOfSiblings > indexOfNode + 1) {
            const newSecondList = generateNode(listType, {content: R.slice(indexOfNode + 1, Infinity, parentList.content)});
            replaceWithArray = R.append(newSecondList, replaceWithArray);
          }

          setCurrentlyEditing({uid: newParagraph.uid, range: newRangeSelection, key: "content"});
          return replaceNodeWithArrayByUID(json, parentList.uid, replaceWithArray);
        } else {
          return setNodeValueByUIDAndKey(json, parentList.uid, "type", listType);
        }
        break;
      case "paragraph":
        newListItem.content = currentlyEditingNode.content;

        setCurrentlyEditing({uid: newListItem.uid, range: newRangeSelection, key: "content"});
        return replaceNodeByUID(json, currentSelection.uid, newNode);
      default:
        setCurrentlyEditing({uid: newListItem.uid, range: newRangeSelection, key: "content"});
        return insertAfterNodeByUIDAtSectionLevel(json, currentSelection.uid, newNode);
    }
  });
}
